// extracted by mini-css-extract-plugin
export default {"root":"Chips_root__I+eW7","content":"Chips_content__SOZ90"};